import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-software-service',
  templateUrl: './software-service.component.html',
  styleUrls: ['./software-service.component.scss']
})
export class SoftwareServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  rating1 = 4.8;
  rating2 = 4.5;
  rating3 = 5.0;
  rating4 = 4.9;

  signUrl = environment.WEB_URL;

   projectPlans = [
    {
        "title": "ERP Implementation",
        "description": "Oracle NetSuite ERP Implementation",
        "price": "$50,000",
        "features": [
            "Full Oracle NetSuite ERP setup and configuration",
            "Data migration from legacy systems",
            "Integration with existing software (up to 3 systems)",
            "Customization of up to 10 reports and 5 workflows",
            "User training for up to 50 employees",
            "60 days post-implementation support",
            "Typical timeline: 3–6 months"
        ],
        "button": "Get started"
    },
    {
        "title": "CRM Solution",
        "description": "Salesforce Sales Cloud Implementation",
        "price": "$30,000",
        "features": [
            "Salesforce Sales Cloud setup and configuration",
            "Data import and cleansing",
            "Integration with marketing automation tools",
            "Custom dashboard and report creation (up to 15)",
            "Email template design and automation setup",
            "User training for up to 30 sales reps",
            "30 days post-implementation support",
            "Typical timeline: 2–4 months"
        ],
        "button": "Get started"
    },
    {
        "title": "E-commerce Platform Development",
        "description": "Custom e-commerce solution built on Shopify Plus",
        "price": "$40,000",
        "features": [
            "Custom Shopify Plus theme development",
            "Product catalog setup (up to 1000 SKUs)",
            "Integration with ERP and CRM systems",
            "Custom checkout process implementation",
            "Payment gateway integration (up to 3 providers)",
            "Order management system setup",
            "Mobile responsive design",
            "SEO optimization",
            "Performance tuning for high-traffic loads",
            "30 days of post-launch support",
            "Typical timeline: 3–5 months"
        ],
        "button": "Get started"
    }
  ]
}
